<template>
	<transition
		name="modal-on"
		:style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]"
	>
		<div class="modal-overlay" @click="close('overlay')" v-if="active">
			<div class="modal-inner" @click.stop :style="modalInner">
				<div class="modal-close-x shadow-box flex-center" @click="close()" v-if="showX">
					<i class="fas fa-times" />
				</div>
				<div class="modal-main-content">
					<slot name="modal-content" />
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

export default {
	data () {
		return {
			active: false
		}
	},
	props: {
		width: {
			type: String,
			default: '94%'
		},

		maxWidth: {
			type: String,
			default: '90%',
		},

		showX: {
			type: Boolean,
			default: true
		},

		closeByClickOnOverlay: {
			type: Boolean,
			default: true
		},

		closeByClickOnEsc: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		open () {
			this.active = true
		},

		close (target) {
			if (target === 'overlay' && this.closeByClickOnOverlay === false) return
			this.active = false
			this.$emit('close')
		},

		closeByKey (e) {
			if (e.keyCode === 27) {
				if (this.closeByClickOnEsc === false) return
				this.close()
			}
		}
	},

	computed: {
		modalInner () {
			return {
				width: this.width,
				maxWidth: this.maxWidth
			}
		}
	},

	mounted () {
		window.addEventListener('keyup', this.closeByKey)
	},

	destroyed () {
		window.removeEventListener('keyup', this.closeByKey)
	}
}

</script>

<style scoped>

.modal-overlay {
	width: 100%;
	height: 100vh;
	background-color: rgba(0,0,0,0.5);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99999;
}

.modal-inner {
	background: white;
	border-radius: 6px;
	border: 1px solid grey;
	position: relative;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.modal-close-x{
	z-index: 1;
	position: absolute;
	top: -10px;
	right: -10px;
	width: 32px;
	height: 32px;
	text-align: center;
	color: #9f9c9c;
	border-radius: 50%;
	font-size: 18px;
	cursor: pointer;
	line-height: 1;
}

.modal-main-content {
	overflow-x: hidden;
	max-height: calc(100vh - 24px);
	overflow-y: auto;
	padding: 30px;
	border-radius: 6px;
}

* >>> .header-legend { 
	border-top:1px solid #EEE; 
	margin:30px 0 10px 0; 
	text-align:center; 
	font-size: 15px; 
} 
* >>> .header-legend > *{ 
	position:relative; 
	top:-13px; 
	background: #ffffff; 
	padding:0 15px; 
}

@media (max-width: 1024px) {
	.modal-close-x{
		width: 42px;
		height: 42px;
		font-size: 30px;
	}
}
</style>
